import { extendObservable, action } from 'mobx';
import i_ from 'i18next';

import { get, form, post, jsonParser } from '../utils/Client';
import { history } from '../';

class AuthenticationStore {
  constructor() {
    extendObservable(this, {
      isAuthenticated: false,

      me: {},

      schemas: [],

      testAuthenticated: action(() =>
        get('/me')
          .then(res => {
            if (res.status === 401 || res.status === 403) {
              this.isAuthenticated = false;
              history.push('/login');
              return Promise.reject();
            } else {
              this.isAuthenticated = true;
              return res;
            }
          })
          .then(jsonParser)
          .then(data => {
            this.me = data;
            if (!this.me.cargo || this.me.cargos.indexOf(this.me.cargo) > -1) {
              this.me.cargo = this.me.cargos[0];
            }
          })
      ),

      login: action((username, password) =>
        form('/authenticate', {
          body: { username, password },
        })
          .then(res => {
            if (res.status === 403) {
              this.isAuthenticated = false;
              localStorage.apiToken = null;
              this.user = {};
              return Promise.reject(i_.t('errors.bad-credentials'));
            } else {
              this.isAuthenticated = true;
              return res.json();
            }
          })
          .then(data => {
            this.me = data.user;
            localStorage.apiToken = data.token;
          })
      ),

      register: action((nome, email, password) =>
        post('/register', {
          body: { nome, email, password },
          credentials: 'omit',
        }).then(res => this.login(email, password))
      ),

      logout: action(() =>
        post('/logout').then(res => {
          this.isAuthenticated = false;
          this.user = {};
          localStorage.clear();
        })
      ),

      setCargo: action(cargo => post(`/usuarios/setcargo/${cargo.id}`)),

      hasRole: action(
        role =>
          this.me.perfil &&
          this.me.perfil.autorizacoes.filter(a => a.nome === role).length > 0
      ),
    });
  }
}

export default new AuthenticationStore();



// WEBPACK FOOTER //
// ./src/stores/AuthenticationStore.js